import { useFieldValue } from 'store/hooks/useFormValues';

export const useGetFieldNumericValue = (fieldName: string) => {
  return +useFieldValue<string>(fieldName, '');
};
